module.exports = __webpack_public_path__ + "img/qrcode_mina.ad16c703.png";